import Vue from "vue";
import numeral from "numeral";
Vue.filter("uppercase", function(value) {
  if (!value) return "";

  return value.toUpperCase().toString();
});
Vue.filter("capitalize", function(value) {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});
Vue.filter("tableheader", function(value) {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});
Vue.filter("first2Chars", (str) => str.substring(0, 2));
Vue.filter("last2Chars", (str) => str.substring(str.length - 2));
Vue.filter("formatPrice", function(value) {
  let val = (value / 1).toFixed(2).replace(".", ",");
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
});
Vue.filter("trgm_numberformate_tbd", function(value) {
  let newval = String(value);
  let temarray = newval.split(".");
  alert(newval +':'+temarray[0]);
  let formatestr = numeral(temarray[0]).format("0,0");
  let result = formatestr;
  if (temarray.length > 1) {
    result = result + "." + temarray[1];
  }

  return result;
});
Vue.filter("trgm_numberformate", function(value) {
  let newval = String(value);
  return new Intl.NumberFormat("en-US").format(newval);
});
Vue.filter("trgm_numberformatenew", function(value) {
  let newval = String(value);
  return new Intl.NumberFormat("en-US").format(newval);
});
Vue.filter("trgm_numberformateInK", function(value) {
  let newval = String(value);
  return new Intl.NumberFormat('en', {
    notation: "compact",
    compactDisplay: "short"
  }).format(newval)
});
Vue.filter("trgm_addpercentagesymbal", function(value) {
  let newval = String(value);
  let result = newval;
  //alert(newval.length);
  if (newval.length > 0) {
    if(newval != 'null'){   result = result + "%";}else{result='';}
 
  }

  return result;
});

export default {};
